import { Clock } from "lucide-react";

export const SOON = [];

export const ComingSoon = ({ compact = false }) => SOON.length > 0 && (
  <section id="coming-soon" data-testid="coming-soon-section" className={compact ? "mt-16 scroll-mt-28" : "container-gf section scroll-mt-28"}>
    <span className="label-chip">Coming soon</span>
    <h2 className="mt-4 text-2xl md:text-3xl">Grandpa's still paddling out</h2>
    <p data-testid="coming-soon-note" className="mt-2 text-slate-600">Not available to buy yet. Sign up for Grandpa's tips to hear when they land.</p>
    <div className="mt-8 grid gap-4 sm:grid-cols-3">
      {SOON.map((c) => (
        <div key={c.id} data-testid={`coming-soon-card-${c.id}`} aria-disabled="true" className="rounded-3xl border border-dashed border-navy/25 bg-sand/60 p-6">
          <span className="inline-flex items-center gap-1 text-[11px] font-semibold uppercase tracking-[0.14em] text-slate-600"><Clock className="h-3 w-3" /> Coming soon</span>
          <p className="mt-3 font-display text-xl">{c.name}</p>
          <p className="mt-1 text-sm text-slate-600">{c.line}</p>
        </div>
      ))}
    </div>
  </section>
);
